import { ERROR_RESET, RESET } from '@pbl/pbl-react-core/lib/models/poll/types';
import { DispatchMethod } from '../index';

export const resetError = () => (dispatch: DispatchMethod) => {
  dispatch({
    type: ERROR_RESET,
    payload: null
  });
};

export const reset = () => (dispatch: DispatchMethod) => {
  dispatch({
    type: RESET,
    payload: null
  });
};
